let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2jhMo")).then(() => parcelRequire('1rEKn'));